import { render, staticRenderFns } from "./ChunkUploader.vue?vue&type=template&id=222877a6&scoped=true"
import script from "./ChunkUploader.vue?vue&type=script&lang=js"
export * from "./ChunkUploader.vue?vue&type=script&lang=js"
import style0 from "./ChunkUploader.vue?vue&type=style&index=0&id=222877a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222877a6",
  null
  
)

export default component.exports